import React from 'react';
const ProfileSkeleton = ({ showEditAction = false }) => (
  <div className="profile-container" aria-busy="true" aria-label="Завантаження профілю">
    <div className="profile-card profile-skeleton">
      <div className="profile-skeleton-heading profile-skeleton-shimmer" />

      <div className="profile-skeleton-identity">
        <div className="profile-skeleton-avatar profile-skeleton-shimmer" />
        <div className="profile-skeleton-name profile-skeleton-shimmer" />
        <div className="profile-skeleton-email profile-skeleton-shimmer" />
      </div>

      <div className="profile-skeleton-tabs" aria-hidden="true">
        {Array.from({ length: showEditAction ? 3 : 2 }).map((_, index) => (
          <div
            className="profile-skeleton-tab profile-skeleton-shimmer"
            key={index}
          />
        ))}
      </div>
      <div className="profile-skeleton-table">
        {Array.from({ length: 7 }).map((_, index) => (
          <div className="profile-skeleton-table-row" key={index}>
            <div className="profile-skeleton-cell profile-skeleton-shimmer" />
            <div className="profile-skeleton-cell profile-skeleton-shimmer" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default ProfileSkeleton;
